import { Grid } from 'theme-ui';
import FeaturedCard from './Card';
type Props = {
  cards: Queries.HomeCollectionCardFragmentFragment[];
};
const FeaturedModule = ({ cards }: Props) => {
  const { length } = cards || [];
  const isCollectionModule = length === 2 || length === 3;
  const desktopColumns = isCollectionModule ? `repeat(${length}, 1fr)` : 'repeat(5, minmax(min-content, 1fr))';

  return (
    <Grid
      sx={{
        gridTemplateColumns: ['1fr', isCollectionModule ? null : desktopColumns, desktopColumns],
        rowGap: ['2.4rem', null, '4.8rem'],
        position: 'relative',
        columnGap: [0, isCollectionModule ? null : '1.2rem', '2.4rem'],
        mx: 'auto',
        maxWidth: 'var(--max-width)',
      }}
    >
      {cards.map((card, index) => (
        <FeaturedCard key={card.id} card={card} index={index} isCollectionModule={isCollectionModule} />
      ))}
    </Grid>
  );
};

export default FeaturedModule;
